import { configureStore } from "@reduxjs/toolkit";
import breadcrumbsReducer from "./breadcrumbsSlice";
import testReducer from "./testSlice";

export const store = configureStore({
  reducer: {
    breadcrumbs: breadcrumbsReducer,
    test: testReducer,
  },
});

export default store;
